import React, { Component } from "react";
import { translate } from "react-i18next";
import { initGA, gaEvent } from "../../ga/analytics";
import {
	CATEGORY_HEADER,
	ACTION_FACEBOOK,
	ACTION_INSTAGRAM,
	ACTION_YOUTUBE,
	ACTION_LINKEDIN,
	ACTION_REGISTER,
	ACTION_TH,
	ACTION_EN,
} from "../../ga/constant";

import flag_thai from "../../assets/media/flag_thai.png";
import flag_eng from "../../assets/media/flag_eng.png";

import { Container } from "../style/global";
import {
	HeaderEL,
	// AbtnHeader,
	NavbarTopLeft,
	NavbarTopRight,
	NavMobile,
} from "../style/header";

class Header extends Component {
	componentDidMount() {
		initGA();
	}

	componentWillMount() {
		if (
			typeof this.props.match.params.lng !== "undefined" &&
			this.props.match.params.lng === "en"
		) {
			this.props.i18n.changeLanguage("en");
		} else {
			this.props.i18n.changeLanguage("th");
		}
	}

	sendToGa = (type) => {
		if (type === "facebook") {
			gaEvent(CATEGORY_HEADER, ACTION_FACEBOOK, this.props.page);
		}
		if (type === "instagram") {
			gaEvent(CATEGORY_HEADER, ACTION_INSTAGRAM, this.props.page);
		}
		if (type === "youtube") {
			gaEvent(CATEGORY_HEADER, ACTION_YOUTUBE, this.props.page);
		}
		if (type === "linkedin") {
			gaEvent(CATEGORY_HEADER, ACTION_LINKEDIN, this.props.page);
		}
		if (type === "Register") {
			gaEvent(CATEGORY_HEADER, ACTION_REGISTER, this.props.page);
		}
		if (type === "th") {
			gaEvent(CATEGORY_HEADER, ACTION_TH, this.props.page);
		}
		if (type === "en") {
			gaEvent(CATEGORY_HEADER, ACTION_EN, this.props.page);
		}
	};

	constructor(props) {
		super(props);
		this.state = {
			activeMenu: false,
			data: this.props.data,
		};
	}

	onClickToggle = () => {
		this.setState({
			activeMenu: !this.state.activeMenu,
		});
	};

	onClickToggleClose = () => {
		this.setState({
			activeMenu: !this.state.activeMenu,
		});
	};

	render() {
		const { t, i18n } = this.props;
		const url_lang = i18n.language === "en" ? "/en" : "";

		const current_change_thai = this.props.currentpage
			.toString()
			.replace("/en", "");
		const current_change_eng =
			"/en" + this.props.currentpage.toString().replace("/en", "");

		return (
			<HeaderEL>
				<Container hideXS>
					<NavbarTopLeft>
						<ul>
							<li>
								<a
									onClick={() => this.sendToGa("facebook")}
									href="https://www.facebook.com/moneytable/"
									rel="noopener noreferrer"
									target="_blank"
								>
									<i className="fab fa-facebook-square fa-lg" />
								</a>
							</li>
							<li>
								<a
									onClick={() => this.sendToGa("youtube")}
									href="https://www.youtube.com/channel/UCT0l1LEsonqTN8lisO2toqw"
									target="_blank"
									rel="noopener noreferrer"
								>
									<i className="fab fa-youtube fa-lg" />
								</a>
							</li>
							<li>
								<a
									onClick={() => this.sendToGa("linkedin")}
									href="https://www.linkedin.com/company/moneytable.com/"
									target="_blank"
									rel="noopener noreferrer"
								>
									<i className="fab fa-linkedin fa-lg" />
								</a>
							</li>
						</ul>
					</NavbarTopLeft>

					<NavbarTopRight>
						<ul>
							<li>
								<a
									href={current_change_thai}
									className={`flag ${i18n.language === "th" ? "active" : ""}`}
									onClick={() => this.sendToGa("th")}
								>
									<img src={flag_thai} alt="thai flag" />
								</a>
								<span style={{ margin: "0px 5px", color: "#ffffff" }}>|</span>
								<a
									href={current_change_eng}
									className={`flag ${i18n.language === "en" ? "active" : ""}`}
									onClick={() => this.sendToGa("en")}
								>
									<img src={flag_eng} alt="eng flag" />
								</a>
							</li>
						</ul>
					</NavbarTopRight>
				</Container>

				<NavMobile>
					<div className="toggle_menu" onClick={this.onClickToggle}>
						<img src="/src/images/icons/menu-toggle.svg" alt="" />
					</div>
					<a href="/" className="logo_mobile">
						<img src="/src/images/logo_mt.png" alt="MoneyTable" />
					</a>
					<div className={`menu_left ${this.state.activeMenu ? "active" : ""}`}>
						<div className="close" onClick={this.onClickToggleClose}>
							<i className="ion-close-round" />
						</div>
						<ul>
							<li>
								<a
									className={`lang flag ${
										i18n.language === "th" ? "active" : ""
									}`}
									href={current_change_thai}
									onClick={() => this.sendToGa("th")}
								>
									<img src={flag_thai} alt="" />
								</a>
								<span style={{ margin: "0px 5px", color: "#eee" }}>|</span>
								<a
									className={`flag ${i18n.language === "en" ? "active" : ""}`}
									href={current_change_eng}
									onClick={() => this.sendToGa("en")}
								>
									<img src={flag_eng} alt="" />
								</a>
							</li>
							<li>
								<a
									className={`${
										this.props.currentpage === `${url_lang}/daycash`
											? "active"
											: ""
									}`}
									href={`${url_lang}/daycash`}
								>
									{t("tm_productDC")}
								</a>
							</li>
							<li>
								<a
									className={`${
										this.props.currentpage === `${url_lang}/aboutus`
											? "active"
											: ""
									}`}
									href={`${url_lang}/aboutus`}
								>
									{t("homepage_about_link")}
								</a>
							</li>
							<li>
								<a
									className={`${
										this.props.currentpage === `${url_lang}/blog`
											? "active"
											: ""
									}`}
									href={`${url_lang}/blog`}
								>
									{t("tm_blog")}
								</a>
							</li>
							<li>
								<a
									className={`${
										this.props.currentpage === `${url_lang}/activity`
											? "active"
											: ""
									}`}
									href={`${url_lang}/activity`}
								>
									{t("tm_activity")}
								</a>
							</li>
							<li>
								<a
									className={`${
										this.props.currentpage === `${url_lang}/career`
											? "active"
											: ""
									}`}
									href={`${url_lang}/career`}
								>
									{t("Careers")}
								</a>
							</li>
							<li>
								<a
									className={`${
										this.props.currentpage === `${url_lang}/contact`
											? "active"
											: ""
									}`}
									href={`${url_lang}/contact`}
								>
									{t("tm_contactus")}
								</a>
							</li>
						</ul>
					</div>
				</NavMobile>
			</HeaderEL>
		);
	}
}

Header.defaultProps = {
	match: {
		params: {
			lng: "",
		},
	},
};

export default translate("translations")(Header);



// WEBPACK FOOTER //
// ./src/components/layouts/header.jsx